import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DefaultLinkWrapper } from './NavItem';

var NavMenuButton = /*#__PURE__*/function (_React$Component) {
  _inherits(NavMenuButton, _React$Component);

  var _super = _createSuper(NavMenuButton);

  function NavMenuButton() {
    _classCallCheck(this, NavMenuButton);

    return _super.apply(this, arguments);
  }

  _createClass(NavMenuButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          _this$props$Wrapper = _this$props.Wrapper,
          Wrapper = _this$props$Wrapper === void 0 ? DefaultLinkWrapper : _this$props$Wrapper,
          rest = _objectWithoutProperties(_this$props, ["children", "className", "Wrapper"]);

      return /*#__PURE__*/React.createElement(Wrapper, _extends({
        className: classNames('cloud-ui-nav-menu-button', className)
      }, rest), children);
    }
  }]);

  return NavMenuButton;
}(React.Component);

_defineProperty(NavMenuButton, "propTypes", {
  href: PropTypes.string,
  Wrapper: PropTypes.func
});

export default NavMenuButton;